import {baseFactoryMethods, Fetcher, ResultType, ResultTypesEnum, UrlResult} from './internal';

export const previewerType: ResultType = {
  name: ResultTypesEnum.PREVIEWER,
  properties: {
    url: UrlResult,
  },
  methods: {
    fetch: new Fetcher(),
    ...baseFactoryMethods,
  },
  immediate: ['url'],
};
